// extracted by mini-css-extract-plugin
export default {"products":"dw-z","card":"ew-z","oosMessaging":"fw-z"};